import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';

interface Tab {
  label: string;
  route: string;
}

@Component({
  standalone: false,
  templateUrl: './direct-edit.component.html',
})
export class DirectEditComponent implements OnInit {
  siteId: string;
  selectedTabIndex = 0;
  tabs: Tab[] = [
    { label: 'Overview', route: 'overview' },
    { label: 'Properties', route: 'properties' },
    { label: 'Property Search', route: 'property-search' },
    { label: 'Domains', route: 'domains' },
    { label: 'Marketing', route: 'marketing' },
    { label: 'Insights', route: 'insights' },
  ];
  $isMobile = this.deviceDetectionService.$isMobile;

  constructor(
    public readonly directEditService: DirectEditService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly deviceDetectionService: DeviceDetectionService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((res) => {
      this.siteId = res.get('siteid');

      this.directEditService.clean();
      this.directEditService.getSite(this.siteId);
      this.setCurrentPathTab();
    });
  }

  onTabChange(index: number): void {
    this.router.navigate([`/direct/sites/${this.siteId}/${this.tabs[index].route}`]);
  }

  setCurrentPathTab() {
    const currentPath = this.router.url;
    const currentTab = this.tabs.findIndex((tab) => currentPath.includes(`/sites/${this.siteId}/${tab.route}`));
    if (currentTab !== -1) {
      this.selectedTabIndex = currentTab;
    }
  }
}
